const ROSTER_UI_SCHEMA = {
  table: {
    items: [
      {
        property: 'employees',
      },
      {
        property: 'employeeId',
      },
      {
        property: 'locations',
      },
      {
        property: 'positions',
      },
      {
        property: 'groups',
        disabledDescription: 'Add groups to this organization.',
      },
      {
        property: 'tags',
        disabledDescription: '', // handled in rosterHeaderComponent
      },
      {
        property: 'shiftTime',
      },
      {
        property: 'status',
        disabledDescription: '', // handled in rosterHeaderComponent
      },
    ],
  },
};

export default ROSTER_UI_SCHEMA;
